const tech = {
  state: {
    // 技术通知
    techModel: {},
    techNoticeBase: {},
    techNoticeEnter: {},
    techVehicleInfo: {},
    techOrderInfo: {},
    techFlowInfo: {},
    // techFlowTotal: 0,
    // 电子工单
    taskModel: {},
    preAuditInfo: {},
    taskInfo: {},
    taskFinish: {}
  },
  getters: {
    techModel: state => state.techModel,
    techNoticeBase: state => state.techNoticeBase,
    techNoticeEnter: state => state.techNoticeEnter,
    techVehicleInfo: state => state.techVehicleInfo,
    techOrderInfo: state => state.techOrderInfo,
    techFlowInfo: state => state.techFlowInfo,
    // techFlowTotal: state => state.techFlowTotal,

    taskModel: state => state.taskModel,
    preAuditInfo: state => state.preAuditInfo,
    taskInfo: state => state.taskInfo,
    taskFinish: state => state.taskFinish
  },
  mutations: {
    techModel: (state, techModel) => {
      state.techModel = techModel
    },
    techNoticeBase: (state, techNoticeBase) => {
      state.techNoticeBase = techNoticeBase
    },
    techNoticeEnter: (state, techNoticeEnter) => {
      state.techNoticeEnter = techNoticeEnter
    },
    techVehicleInfo: (state, techVehicleInfo) => {
      state.techVehicleInfo = techVehicleInfo
    },
    techOrderInfo: (state, techOrderInfo) => {
      state.techOrderInfo = techOrderInfo
    },
    techFlowInfo: (state, techFlowInfo) => {
      state.techFlowInfo = techFlowInfo
    },
    // techFlowTotal: (state, techFlowTotal) => {
    //   state.techFlowTotal = techFlowTotal
    // },
    // 电子工单
    taskModel: (state, taskModel) => {
      state.taskModel = taskModel
    },
    preAuditInfo: (state, preAuditInfo) => {
      state.preAuditInfo = preAuditInfo
    },
    taskInfo: (state, taskInfo) => {
      state.taskInfo = taskInfo
    },
    taskFinish: (state, taskFinish) => {
      state.taskFinish = taskFinish
    }
  },
  actions: {
    handleTechModel (techModel, data) {
      techModel.commit('techModel', data)
    },
    handleTechNoticeBase (techNoticeBase, data) {
      techNoticeBase.commit('techNoticeBase', data)
    },
    handleTechNoticeEnter (techNoticeEnter, data) {
      techNoticeEnter.commit('techNoticeEnter', data)
    },
    handleTechVehicleInfo (techVehicleInfo, data) {
      techVehicleInfo.commit('techVehicleInfo', data)
    },
    handelTechOrderInfo (techOrderInfo, data) {
      techOrderInfo.commit('techOrderInfo', data)
    },
    handleTechFlowInfo (techFlowInfo, data) {
      techFlowInfo.commit('techFlowInfo', data)
    },
    // handleTechFlowTotal (techFlowTotal, data) {
    //   techFlowTotal.commit('techFlowTotal', data)
    // },
    // 电子工单
    handleTaskModel (taskModel, data) {
      taskModel.commit('taskModel', data)
    },
    handlePreAuditInfo (preAuditInfo, data) {
      preAuditInfo.commit('preAuditInfo', data)
    },
    handleTaskInfo (taskInfo, data) {
      taskInfo.commit('taskInfo', data)
    },
    handleTaskFinish (taskFinish, data) {
      taskFinish.commit('taskFinish', data)
    }
  }
}

export default tech
